import { defineComponent as _defineComponent } from 'vue'
import BigField from '@/_legacy/views/ChecklistBuilder/BigField.vue';
  import { CheckboxField } from '@/ui/components/form';
  import { Tag } from '@/ui/components/Tag';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiAnonymization',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
  setup(__props, { emit }: { emit: ({(e: 'input', value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props;

  

  

  const onInput = (newValue: boolean) => {
    emit('input', newValue);
  };

return { __sfc: true,props, emit, onInput, BigField, CheckboxField, Tag, t }
}

})